import { cn } from '../../common/functions/cn';
import { ButtonV2 } from '../button-v2/button-v2';
import { Tooltip, TooltipContent, TooltipTrigger } from '../tooltip/tooltip';
import type { DynamicFormButtonSetting } from './dynamic-form.interfaces';

const MAX_DISPLAY_LENGTH = 24;
const TRUNCATED_LENGTH = 21;

interface DynamicFormButtonProps {
  button: DynamicFormButtonSetting;
  readOnly?: boolean;
  fullWidth?: boolean;
}

const DynamicFormButton = ({ button, readOnly, fullWidth = false }: DynamicFormButtonProps) => {
  const fullText = button.text;
  const showTooltip = fullText.length > MAX_DISPLAY_LENGTH;
  const displayText = showTooltip ? `${fullText.substring(0, TRUNCATED_LENGTH)}...` : fullText;
  const disabled = button.disabled === undefined ? readOnly : button.disabled;

  return (
    <Tooltip>
      <TooltipTrigger
        disabled={!showTooltip}
        render={
          <ButtonV2
            variant={button.variant}
            className={cn(fullWidth && 'w-full', button.className)}
            type={button.type}
            disabled={disabled}
            hidden={button.hidden}
            onClick={button.onClick}
            size="lg"
          >
            {displayText}
          </ButtonV2>
        }
      />
      <TooltipContent className="max-w-none whitespace-nowrap">{fullText}</TooltipContent>
    </Tooltip>
  );
};

export default DynamicFormButton;
